import { Skeleton } from '@/components/ui/skeleton';
import BrandLogo from './BrandLogo';

interface PageLoaderProps {
  fullScreen?: boolean;
}

const PageLoader = ({ fullScreen = false }: PageLoaderProps) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <BrandLogo size="lg" animate className="shadow-gold-glow" />
          <div className="flex flex-col items-center gap-1">
            <p className="text-sm font-medium text-foreground">Loading...</p>
            <p className="text-xs text-muted-foreground">Please wait</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 p-2 animate-fade-in">
      {/* Skeleton shimmer rows to mimic page content */}
      <div className="flex items-center gap-3">
        <Skeleton className="h-10 w-10 rounded-xl shrink-0" />
        <div className="flex flex-col gap-2 flex-1">
          <Skeleton className="h-4 w-1/3 rounded-md" />
          <Skeleton className="h-3 w-1/2 rounded-md" />
        </div>
      </div>
      <Skeleton className="h-32 w-full rounded-2xl" />
      <div className="grid grid-cols-3 gap-4">
        <Skeleton className="h-20 rounded-xl" />
        <Skeleton className="h-20 rounded-xl" />
        <Skeleton className="h-20 rounded-xl" />
      </div>
      <Skeleton className="h-48 w-full rounded-2xl" />
    </div>
  );
};

export default PageLoader;
